import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { connect } from 'react-redux';
import { Text, Box } from '@as/cotopaxi';
import { makeGetProductFulfillment, makeGetProductFulfillmentBySize, } from '../../redux/product/selectors/ProductSelector';
const ProductFulfillmentContainer = ({ fulfillment: { ccExcluded, hdExcluded, fulfillmentCopyDescription }, fulfillmentBySize: { storeSourceExcluded }, }) => {
    const { checkoutCc: clickAndCollectEnabled } = useAemConfig();
    const availableInStoreOnly = ccExcluded && (hdExcluded || storeSourceExcluded);
    if (!availableInStoreOnly || !clickAndCollectEnabled) {
        return null;
    }
    return (_jsx(Box, { mobile: { spacing: { marginTop: 2 } }, children: _jsx(Text, { inline: true, children: fulfillmentCopyDescription }) }));
};
const makeMapStateToProps = () => {
    const getProductFulfillment = makeGetProductFulfillment();
    const getProductFulfillmentBySize = makeGetProductFulfillmentBySize();
    const mapStateToProps = (state) => ({
        fulfillment: getProductFulfillment(state),
        fulfillmentBySize: getProductFulfillmentBySize(state),
    });
    return mapStateToProps;
};
export default connect(makeMapStateToProps)(ProductFulfillmentContainer);
